// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1384c6d0 {
  min-width: unset;
  border-color: #ccc;
  box-shadow: 0 8px 17px 0 rgb(0 0 0 / 20%);
  background: white;
  max-height: 260px;
  top: var(--_18w76bwm);
}
@media screen and (min-width: 768px) {
  ._1384c6d0 {
    min-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["._1384c6d0 {\n  min-width: unset;\n  border-color: #ccc;\n  box-shadow: 0 8px 17px 0 rgb(0 0 0 / 20%);\n  background: white;\n  max-height: 260px;\n  top: var(--_18w76bwm);\n}\n@media screen and (min-width: 768px) {\n  ._1384c6d0 {\n    min-width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
